import React from 'react'
import { copyTextToClipboard } from 'helpers'
import './style.css'
import cs from 'classnames'

import PageContainer from 'component/page-container'

/* global API */

const registrationURL = 'https://club.vatrikovsky.ru/registration/';



const InviteRoute = () => {
    const [invite, setInvite] = React.useState('')
    const [copied, setCopied] = React.useState(false)
    const handleGenerateBtn = () => {
        (async () => {
            const data = await API.instance().createInvite()
            setInvite(registrationURL + data.code)
        })()
    }

    // const [users, setUsers] = React.useState([])
    // React.useEffect(() => {
    //     (async () => {
    //         setUsers(await API.instance().getUserList())
    //     })()
    // }, [])

    // const [inviteData, setInviteData] = React.useState([])
    // React.useEffect(() => {
    //     (async () => {
    //         setInviteData(await API.instance().getInviteList())
    //     })()
    // }, [])

    return (
        <PageContainer className="invite-page" h1="Раздача инвайтов">
            <div className="page__inner">
                <p>Прежде чем приглашать человека в клуб, представьте его участникам и получите одобрение. Пока просто в чатике.</p>
                <p>Потом расскажите будущему новичку о клубе. Например, так:</p>

                <div className="container">
                    <div className="quote">
                        <p>Клуб — объединение приятных и интересных людей. Одной компанией в ДнД играем, другой — в настолки, третьей — на гитарах, четвертой на велосипедах катаем и т. д. По чуть-чуть все рано или поздно перезнакомятся, то есть у тебя появятся хорошие компаньоны в делах, социальные связи. Мы стараемся приглашать надёжных ребят, так что всем участникам Клуба доверяем, ждём и от тебя того же =)</p>
                        <p>Не обязательно участвовать во всем подряд, мы даже рекомендуем замьютить чаты. Все главные новости присылаются в канал, ничего не пропустишь, даже если пролистаешь 500 непрочитанных в чате.</p>
                        <p>Мы постепенно добавляем автоматизированные штуки (для того и нужна регистрация).</p>
                        <p>Например: в чатике настолок кидаешь сообщение, что в пятницу играем в «Игру Престолов» в таком-то антикафе, бот его подхватывает и добавляет в календарь всем участникам чата. Событие можно комментировать прямо в телеге: слать картинки, летописать настолки, впечатления — это всё автоматически организуется ботом.</p>
                        <p>Еще пример: есть бот, который делает стикеры из мемных фраз. Указываешь ему сообщение — он добавляет стикер. Бывает весело.</p>
                        <p>Так что, хочешь с нами?</p>
                    </div>
                </div>
                <p>Если всем все ок — отправьте ссылку-приглашение:</p>
                <button
                    className="button_create-invite"
                    onClick={handleGenerateBtn}
                >
                    Сгенерировать ссылку-приглашение
            </button>
                {!!invite.length && (
                    <div
                        className={cs(
                            'new-invite',
                            'new-invite_created',
                            { 'new-invite_copied': copied }
                        )}
                        onClick={() => copyTextToClipboard(invite, () => setCopied(true))}
                    >
                        {invite}
                    </div>
                )}
                {/* <div className="container">
                <h3>История инвайтов</h3>
                </div>
                <div className="container invite-list">
                    {inviteData.map(curInvite => (
                        <div>
                            <div>https://club.vatrikovsky.ru/registration.php?invite={curInvite.code}</div>
                            <div>{users.filter(i => i.id === curInvite.userId).map(i => `${i.name} ${i.surname}`)}</div>
                            <div>{curInvite.isUsed === 1 && 'Использован'}</div>
                        </div>
                    ))}
                </div> */}
            </div>
        </PageContainer>
    )
}

export default InviteRoute
